(() => {
  const drawer = document.getElementById('CrestlaneCartDrawer');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  const sectionId = drawer.dataset.sectionId;
  const root = drawer.dataset.root;
  const status = drawer.querySelector('[data-cl-cart-status]');
  let busy = false;
  let opener = null;

  function announce(message = '', error = false) {
    status.textContent = message;
    status.dataset.error = String(error);
  }

  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-cl-cart-quantity], [data-cl-step], [data-cl-cart-remove], [name="checkout"]').forEach(control => { control.disabled = value; });
    if (!value) drawer.querySelectorAll('.cl-quantity input').forEach(syncCrestlaneQuantity);
  }

  function syncHeader(content) {
    document.querySelectorAll('.cl-cart-link').forEach(link => {
      link.setAttribute('aria-label', content.dataset.cartLabel);
      let badge = link.querySelector('span');
      if (Number(content.dataset.count) > 0) {
        if (!badge) { badge = document.createElement('span'); link.append(badge); }
        badge.textContent = content.dataset.count;
      } else if (badge) badge.remove();
    });
  }

  function render(html, focusKey) {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-cl-cart-content]');
    if (!content) return false;
    drawer.querySelector('[data-cl-cart-content]').replaceWith(content);
    content.querySelectorAll('.cl-quantity input').forEach(syncCrestlaneQuantity);
    syncHeader(content);
    syncCrestlaneCartLimits(content);
    if (focusKey && drawer.open) {
      const quantity = Array.from(content.querySelectorAll('[data-cl-cart-quantity]')).find(input => input.dataset.key === focusKey);
      (quantity || drawer.querySelector('[data-cl-cart-close]')).focus({ preventScroll: true });
    }
    return true;
  }

  async function refresh(focusKey) {
    const url = new URL(root, window.location.origin);
    url.searchParams.set('sections', sectionId);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(drawer.dataset.error);
    const sections = await response.json();
    if (!render(sections[sectionId], focusKey)) throw new Error(drawer.dataset.error);
  }

  function open(trigger) {
    if (drawer.open) return;
    opener = trigger || document.activeElement;
    drawer.showModal();
    document.documentElement.classList.add('cl-cart-open');
    document.querySelectorAll('.cl-cart-link').forEach(link => link.setAttribute('aria-expanded', 'true'));
  }

  function close() { drawer.close(); }

  function formStatus(form, message, error) {
    let notice = form.querySelector('[data-cl-cart-form-status]');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'cl-cart-form-status';
      notice.dataset.clCartFormStatus = '';
      notice.setAttribute('role', 'status');
      form.querySelector('[name="add"]').before(notice);
    }
    notice.dataset.error = String(error);
    notice.textContent = message;
  }

  document.querySelectorAll('.cl-cart-link').forEach(link => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', drawer.id);
    link.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.cl-product-form')) return;
    event.preventDefault();
    if (busy || form.dataset.clSubmitting === 'true') return;
    const submit = form.querySelector('[name="add"]');
    if (!submit || submit.disabled) return;
    const body = new FormData(form);
    body.set('sections', sectionId);
    body.set('sections_url', window.location.pathname);
    form.dataset.clSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    submit.disabled = true;
    formStatus(form, drawer.dataset.loading, false);
    setBusy(true);
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : drawer.dataset.error);
      added = true;
      if (!render(data.sections?.[sectionId])) await refresh();
      formStatus(form, drawer.dataset.added, false);
    } catch (error) {
      formStatus(form, added ? drawer.dataset.added : (error.message || drawer.dataset.error), !added);
      // A completed addition must never be retried or open the cart on a refresh failure.
    } finally {
      form.dataset.clSubmitting = 'false';
      form.removeAttribute('aria-busy');
      setBusy(false);
      form.querySelectorAll('.cl-quantity input').forEach(syncCrestlaneQuantity);
    }
  });

  async function changeQuantity(key, quantity) {
    if (busy) return;
    setBusy(true);
    announce(drawer.dataset.loading);
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: sectionId, sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : drawer.dataset.error);
      if (!render(data.sections?.[sectionId], key)) await refresh(key);
      announce(drawer.dataset.updated);
    } catch (error) {
      try { await refresh(key); } catch { drawer.querySelectorAll('[data-cl-cart-quantity]').forEach(input => { input.value = input.dataset.quantity; }); }
      announce(error.message || drawer.dataset.error, true);
    } finally { setBusy(false); }
  }

  document.addEventListener('click', async event => {
    const link = event.target.closest('.cl-cart-link');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(link);
    if (busy) return;
    setBusy(true);
    announce(drawer.dataset.loading);
    try { await refresh(); announce(); }
    catch (error) { announce(drawer.dataset.error, true); }
    finally { setBusy(false); }
  });

  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-cl-cart-close]')) { close(); return; }
    const remove = event.target.closest('[data-cl-cart-remove]');
    if (remove && !remove.disabled) changeQuantity(remove.dataset.clCartRemove, 0);
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
  });

  drawer.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[data-cl-cart-quantity]')) return;
    const value = Number(input.value);
    if (!Number.isInteger(value) || value < 0) { input.value = input.dataset.quantity; return; }
    if (value !== Number(input.dataset.quantity)) changeQuantity(input.dataset.key, value);
  });

  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('cl-cart-open');
    document.querySelectorAll('.cl-cart-link').forEach(link => link.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
})();
